import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { apiClient } from "../service/tekkr-service";

export const useDeleteProjectMutation = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    return useMutation({
        mutationFn: async (projectId: string) => {
            await apiClient.deleteProject({
                params: { id: projectId },
            });
        },
        onSuccess: async () => {
            await queryClient.refetchQueries({
                queryKey: ["project-list"],
            });
            navigate("/projects");
        },
    });
};
